import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=d4740d58&scoped=true&"
import script from "./Distributor.vue?vue&type=script&lang=js&"
export * from "./Distributor.vue?vue&type=script&lang=js&"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=d4740d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4740d58",
  null
  
)

export default component.exports